import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';

export default class InterestedList extends Component {
	oninit(vnode) {
		super.oninit(vnode);
		this.likedUsers = null;
		this.loadLikes();
	}

	loadLikes() {
		const post = this.attrs.post;
		app.store.find('users', { filter: { liked: post.id() }, page: { limit: 50 } }).then((users) => {
			this.likedUsers = users;
			m.redraw();
		});
	}

	isInterested() {
		if (!app.session.user || !this.likedUsers) return false;
		return this.likedUsers.some((user) => user.id() === app.session.user.id());
	}

	getLikedUsers() {
		return this.likedUsers || [];
	}

	toggleInterest() {
		if (!app.session.user) {
			import('flarum/forum/components/LogInModal').then(({ default: LogInModal }) => {
				app.modal.show(LogInModal);
			});
			return;
		}

		const post    = this.attrs.post;
		const isLiked = !this.isInterested();

		post.save({ isLiked }).then(() => {
			this.loadLikes();
		});

		// Optimistic update
		if (isLiked) {
			this.likedUsers = [...(this.likedUsers || []), app.session.user];
		} else {
			this.likedUsers = (this.likedUsers || []).filter(u => u.id() !== app.session.user.id());
		}

		m.redraw();
	}


	view() {
		const interested = this.isInterested();
		const users      = this.getLikedUsers();

		return (
			<div className="EventInterested">
			<Button
			className={'Button EventInterested-button ' + (interested ? 'Button--primary' : '')}
			icon={interested ? 'fas fa-star' : 'far fa-star'}
			onclick={() => this.toggleInterest()}
			>
			{interested
				? app.translator.trans('kemze-calendar.forum.event.not_interested')
				: app.translator.trans('kemze-calendar.forum.event.interested')}
			</Button>

			{users.length > 0 && (
				<div className="EventInterested-list">
				<span className="EventInterested-label">
				{app.translator.trans('kemze-calendar.forum.event.interested_by')}
				</span>
				<div className="EventInterested-users">
				{users.map((user) => user && (
					<Link
					key={user.id()}
					href={app.route.user(user)}
					title={user.displayName()}
					className="EventInterested-user"
					>
					{avatar(user)}
					<span className="EventInterested-username">{username(user)}</span>
					</Link>
				))}
				</div>
				</div>
			)}

			{users.length === 0 && (
				<div className="EventInterested-empty">
				{app.translator.trans('kemze-calendar.forum.event.no_interest')}
				</div>
			)}
			</div>
		);
	}
}
